import { Buffer } from 'buffer'

const TEST = '5'
const JWT_TOKEN = 'JWT_TOKEN'
const SPICE_ID = 'SPICE_ID'
const SG_TOKEN = 'SG_TOKEN'
const QURE_TOKEN = 'QURE_TOKEN'
const USER_ID = 'USER_ID'
const UPGRADE_FLOW_FLAG = 'UPGRADE_FLOW_FLAG'
const FAMILY_WARNING = 'FAMILY_WARNING'
const X_SEGMENT = 'X_SEGMENT'
const LOCALSTORAGE_NAMESPACE = 'DCX'
const COOKIE_NAMESPACE = 'DCX'
const COOKIE_DOMAIN =
  process.env.NODE_ENV !== 'production'
    ? 'localhost'
    : '.jp.iqos.com'
const REACT_LOGIN_SUCCESS_EVENT = 'DCX_REACT_LOGIN_SUCCESS'
const IMAGE_ALT_DEFAULT_VALUE = 'のイメージ画像'

const stage = process.env.STAGE || 'dev'

const SITE_BASE_URL =
  process.env.NODE_ENV !== 'production'
    ? `https://${stage}.iqos.jp`
    : 'http://jp.iqos.com'

const IQOSPHERE_SITE_BASE_URL =
  process.env.NODE_ENV !== 'production'
    ? `https://iqosphere.${stage}.iqos.jp`
    : 'https://iqosphere.jp.iqos.com'

const apiGatewayUrlMap = {
  dev: 'https://api.dev.iqos.jp',
  qas: 'https://api.qas.iqos.jp',
  pre: 'https://api.jp.stg-iqos.com',
  prod: 'https://api.jp.iqos.com'
}

const BASE_URL =
  process.env.NODE_ENV !== 'production'
    ? apiGatewayUrlMap[stage]
    : 'https://api.jp.iqos.com'

const IMAGE_BASE_URL =
  process.env.NODE_ENV !== 'production'
    ? `https://cdn-${stage}.iqos.jp/react-components/images`
    : 'https://cdn.iqos.jp/react-components/images'

const IMAGE_QURE_URL =
  process.env.NODE_ENV !== 'production'
    ? `https://cdn-${stage}.iqos.jp/images/qure`
    : 'https://cdn.iqos.jp/images/qure'

const DOCOMO_LOGIN_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://id.smt.docomo.ne.jp/cgi8/oidc/authorize'
    : 'https://id.smt.docomo.ne.jp/cgi8/oidc/authorize'
const DOCOMO_CLIENT_ID =
  process.env.NODE_ENV !== 'production'
    ? 'g00_0039_0012_00'
    : 'g00_0039_0011_00'
const DOCOMO_REDIRECT_URI =
  process.env.NODE_ENV !== 'production'
    ? 'https://jp.stg-iqos.com/register'
    : 'http://jp.iqos.com/profiles-new'
const DOCOMO_SCOPE =
  'openid subscriber_info_all_provide identification_info_all_provide email user_info_all_provide'
const DOCOMO_RESPONSE_TYPE = 'code'

const FAQ_APPLICATION_ID =
  process.env.NODE_ENV !== 'production'
    ? 's3LgTfx2XGh8tZP2jKRN8eZvgFcXGmXnN'
    : 's3LgTfx2XGh8tZP2jKRN8eZvgFcXGmXnN'

const FAQ_SECRET_KEY =
  process.env.NODE_ENV !== 'production'
    ? 'yRYhh3JwA8EKdqrDCCZGNXxqV3hYRbDEJCjRJAzuMUuPG3QGFUbbR5PJ3m83wNYX9ex6XQhvhJPYQrJUvYfSY58AuLrCLwqL'
    : 'yRYhh3JwA8EKdqrDCCZGNXxqV3hYRbDEJCjRJAzuMUuPG3QGFUbbR5PJ3m83wNYX9ex6XQhvhJPYQrJUvYfSY58AuLrCLwqL'

const QURE_APPLICATION_ID =
  process.env.NODE_ENV !== 'production'
    ? '95e585aa4ca5385df22151fa5eeddfc97'
    : '95e585aa4ca5385df22151fa5eeddfc97'

const CDN_REACT_DIST_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://localhost:3000'
    : 'https://cdn.iqos.jp/val/react-components/umd'

const CDN_TRANSLATIONS_URL =
  process.env.NODE_ENV !== 'production'
    ? `https://cdn-${stage}.iqos.jp/translations`
    : 'https://cdn.iqos.jp/translations'

const QURE_SECRET_KEY =
  process.env.NODE_ENV !== 'production'
    ? '4bc37a6c29667fb4eae0037e4f1a49f7638a48b7dd2fe8cc279d4aa16a6acebbd6158873e3b9e6ec36995b0628451c49'
    : '4bc37a6c29667fb4eae0037e4f1a49f7638a48b7dd2fe8cc279d4aa16a6acebbd6158873e3b9e6ec36995b0628451c49'

const QURE_TRACK_ACTION = '447dffe0-cc2d-4ecf-b30e-3a9f37c6c3cd'
const QURE_DEFAULT_LANGUAGE = 'ja'
const QURE_CHATBOT_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://ocsg-pre.chat.iqos.jp/u/iqosjp/qureout/128'
    : 'https://ocsg.chat.iqos.jp/u/iqosjp/qureout/128'

const DEFAULT_DATE_FORMAT = 'yyyy年MM月dd日'

const LINE_BASE_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://line.iqosqa.jp'
    : 'n/a'

const RECAPTCHA_BASE_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://www.google.com/recaptcha/'
    : 'https://www.google.com/recaptcha/'

const RECAPTCHA_V3_SITE_KEY =
  process.env.NODE_ENV !== 'production'
    ? '6LfEuecUAAAAABYNhP90FlQehNzgkLdx6LWSZLIf'
    : '6Lf97fcmAAAAAMfnUKbCf2j66ZQdyU2cr3qHOaUi'

const RECAPTCHA_V2_SITE_KEY =
  process.env.NODE_ENV !== 'production'
    ? '6LftuecUAAAAAF54TxvxQ8CwkmYlYgnDMpOGhlqb'
    : '6LfZL1UoAAAAAOyWCFolXWZWloiZRCnjDeCGr6ZG'

const SCANDIT_LICENSE_KEY =
  process.env.NODE_ENV !== 'production'
    ? 'ATUhxDVSEWCmKPbTmBF63Tc6t886KBk0Q11nqtVg8xMrW/2mw0TBUqZopgGsQU+bJiSs4AMPKbXZbGdfC2tbSQBu897renPuM05518lZha0pbLS35FjXthNNiK9bRS2R21ef8f1Fe2HtEpI1mi1HVvoYKnmyF9JwRCHnzvwetF0mI8rE/m3G+O9MLyTiuvAIPCJzlXUnFKbQ0dLcPE94fxV3GRPswQPqFZfTbyO1NXoLxjqGUi5NXo+ge6UtTVjJXiaZhvXqXTj2PqUEzmB3XbLMtX+Oxk08Eg1sV/p3waRm1PbJcozNYLTEw4B0EgpijsR7FxajUl/6/H5i1mF1Dvp6HBIa+zSTlWudoLZVM18RFNHKAwHAPOW20XALSjJ6sj5gdCbIgwr9N/yT3xt1Q95BFmp/vEBm22rmp4+hnI56UN17k6p2IRPP0KYRQgwRMO50cobzi4PcbnW4MQV+sYm2ERT1cuypRqwnwpJcCotBnhLVGhATeWw5aacHZN0k6nIk/mWwTwzBl6UVx6fqxjqE+yNNZvT6R1MU3xPY7fEQWuUcAdb8NpMxXRMBjaRfhnKzAVfdq/rNzZvwuQyBzH9BdWh7GibUlesDydOxPxcoKfHAf4f9oNiBMPLlMmdPD/qTuPPY+mVrqa9Tbjsa7WsTvkjNwrd6MBDhdd0mMksCShfY3AFzAUfYv4HCR5ENfQJc2MGa53mKwXqdjg6qM9LJtF+E1TpoikeznqAHCyqcXuiHOivsETbuP/sQJoIjkhQzIU3rkWgMR3FfQsI9TuJWFKGc1cXoNpyZICobMTTd0X1LHBPDb/nvlL1oTinGC1xz/MiOTUMFdFjsJBg='
    : 'AaN+TruBL16VN0WAqCI6WTsju2QaBvmN5H+AzvZLoBfzQZUI5UWngclO6cd5CcBlKHJWLftwbCv2Kzmh1iyC83F7mITiCtBnq03UUQpMJ6FbfHhDOlr4MqRolfV1HnxIBCrEuOgTKGm/b4UtZdWkFSJ5tcX0ZjJQ3SCccjQGw5pXHxmVQlFhkKBoW3LA2kRsfIeNsCO9jc0YzuD9yOeSGtT+TYh7ogTpYis/aIdwp2jBLD7MpCIwXu8go9m/+E4icVUsZkguyxSaCOkI21SUAedQY+I0Q630GTKyqK2X+pG24YkrKF6wClfVTzn3oFEYtLq2fb6Vo2NeU6tTHyaWJCPovR/c+pdmJ3fTBFoNrYHIzSXFI5VOpMFIgCAr81yD7BDMr8jzHnQkpqLV1pR4NfmzrxdUt5YxuBmFGqstVpiodB25ovPl/MljThLvADb4x9voydcV2RsSeyPgADt2QAaVv7js3gvFKcaev3lZPBaeCbA8+vndzHYYS7dJ+1Hr5hDNr99ws6xQlpr+AOnMD2z/UTAW4Tr8++Eq0V0mQqCZyuqeJbod4Vaem3ZeE6U3QzvJiFuXBGYS2m8DYb7XHUJ/eC2lZzDATefaoHVE6KGtsVhfYJxrOySP9OyUQzKKYBzcmodF0YnnqtZGkAWtxuDx55ZDUBglmZKkR3/74eyYH2l0XfEcT0o/DObmMWJT5itsnDnxj8yS0QJT+4DhwKmRfqiBYmjDHFJ5gglHW3kUH0gUneSS46yOooZgVMymcdiOlwsFyZCxlrOSSHdGMqem3FLhkkQFMYZgDkyU9cFJk06eKgcqAy4='

const SCANDIT_SDK_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://cdn.jsdelivr.net/npm/scandit-sdk@4.6.0/build/'
    : 'https://cdn.iqos.jp/val/react-components/umd/scandit-sdk'
//  'https://cdn.jsdelivr.net/npm/scandit-sdk@4.6.0/build/'

const APPLICATION_ID =
  process.env.NODE_ENV !== 'production' ? 'JPIS' : 'VJPIS'

const APPLICATION_KEY =
  process.env.NODE_ENV !== 'production'
    ? 'c8378325-51cb-4b38-9eed-5862d3bdc6d5'
    : '1d768642-5da8-45f0-8987-ec915d64a3d2'

const APPLICATION_ID_BACKEND =
  process.env.NODE_ENV !== 'production'
    ? 'JPISB'
    : 'VJPISB'

const APPLICATION_KEY_BACKEND =
  process.env.NODE_ENV !== 'production'
    ? 'f8bb485d-dae0-41cc-b533-6fa4e09d9e66'
    : '79d0c525-d802-4bbb-b1bc-8535be4a4d99'

const ADYEN_SCRIPT_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/4.3.1/adyen.js'
    : 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/4.3.1/adyen.js'

const ADYEN_STYLES_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/4.3.1/adyen.css'
    : 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/4.3.1/adyen.css'

const ADYEN_ORIGIN_KEY =
  process.env.NODE_ENV !== 'production'
    ? 'pub.v2.8215851732481131.aHR0cDovL2xvY2FsaG9zdDozMDAw.I7F3InIMyoIWNOgNsudEIpsm5BeH-KPFV-1dPH7WzwY'
    : 'pub.v2.2615687282571387.aHR0cHM6Ly9qcC5pcW9zLmNvbQ.2HPFaWBXtT_0GeZBgKYN5lxs7xcyu1gLf1X0Rc65q84'

const ADN_FINGERPRINT_URL =
  process.env.NODE_ENV !== 'production'
    ? 'https://live.adyen.com/hpp/js/df.js'
    : 'https://live.adyen.com/hpp/js/df.js'

const ADN_ENVIRONMENT =
  process.env.NODE_ENV !== 'production'
    ? 'test'
    : 'live'

const ADDRESS_REGEX_VALIDATION =
  process.env.NODE_ENV !== 'production'
    ? String.raw`[#。＿＼〕」≠′☆▲⊆⇔≪;\\：ヽ∥［『＜″★▽⊇∀≫\`$；ヾ｜］』＞℃○▼⊂∃√^{%゛ゝ…｛【≦￥●→⊃∠∽_}*゜ゞ‥｝】≧＄~◎←∪⊥∝/｢@´〃‘〈＋∞￠◇↑∩⌒∵\\｣｀仝〉±∴￡◆↓∧∂∫|+¨〆“《×♂％□〓∨∇∬\`=＾〇”》÷♀＊■∈￢≡｡'<￣／〔「＝°§△∋⇒≒:>\[\]]` // PMIRRPJP-18212
    : Buffer.from('WyPjgILvvL/vvLzjgJXjgI3iiaDigLLimIbilrLiiobih5Tiiao7XFzvvJrjg73iiKXvvLvjgI7vvJzigLPimIXilr3iiofiiIDiiatcYCTvvJvjg77vvZzvvL3jgI/vvJ7ihIPil4vilrziioLiiIPiiJpeeyXjgpvjgp3igKbvvZvjgJDiiabvv6Xil4/ihpLiioPiiKDiiL1ffSrjgpzjgp7igKXvvZ3jgJHiiafvvIR+4peO4oaQ4oiq4oql4oidL++9okDCtOOAg+KAmOOAiO+8i+KInu+/oOKXh+KGkeKIqeKMkuKItVxc772j772A5Lud44CJwrHiiLTvv6Hil4bihpPiiKfiiILiiKt8K8Ko44CG4oCc44CKw5fimYLvvIXilqHjgJPiiKjiiIfiiKxcYD3vvL7jgIfigJ3jgIvDt+KZgO+8iuKWoOKIiO+/ouKJoe+9oSc877+j77yP44CU44CM77ydwrDCp+KWs+KIi+KHkuKJkjo+XFtcXV0=', 'base64').toString()

const DEBUG_TRANSLATIONS = 'DEBUG_TRANSLATIONS'
const DEBUG_TRANSLATIONS_ENABLED =
  process.env.NODE_ENV !== 'production'
    ? 'true'
    : 'false'

const CDN_DIGITAL_EVENT_URL =
  process.env.NODE_ENV !== 'production'
    ? `https://cdn-${stage}.iqos.jp/animation/iluma_immersion/dist`
    : 'https://cdn.iqos.jp/animation/iluma_immersion/dist'

const REGISTRATION_GRECAPTCHA_ACTION = 'registration'
const VERIFY_EMAIL_PIN_GRECAPTCHA_ACTION = 'registration_email_pin'
const VERIFY_PHONE_PIN_GRECAPTCHA_ACTION = 'registration_phone_pin'
const STOCK_NOTIFICATION_GRECAPTCHA_ACTION = 'stocknotification'
const RECOVER_PASSWORD_GRECAPTCHA_ACTION = 'recover_password'
const RECOVER_ID_GRECAPTCHA_ACTION = 'recover_id'
const CAPTCHA_VALIDATION_ERROR_01 = 'rec_01'
const CAPTCHA_VALIDATION_ERROR_02 = 'rec_02'
const EXPIRY_DATE_DELIMITER = '/'
const COOKIE_REACT_OVERWRITE_ROUTE_REGISTER = 'React_Overwrite_Route_Register'
const COOKIE_SKIPPED_OCR = 'SKIPPED_OCR'
const COOKIE_SHOW_SKIPPED_TOAST = 'SHOW_SKIPPED_TOAST'
const DCX_PROMOTIONS_NOTIFICATIONS_SEEN = 'DCX__promotions_notifications_seen'
const IQOSPHERE_PROFILE = 'LOYALTY_POSITION'

export default {
  TEST,
  LOCALSTORAGE_NAMESPACE,
  COOKIE_NAMESPACE,
  COOKIE_DOMAIN,
  SITE_BASE_URL,
  IQOSPHERE_SITE_BASE_URL,
  BASE_URL,
  JWT_TOKEN,
  SPICE_ID,
  SG_TOKEN,
  QURE_TOKEN,
  USER_ID,
  IMAGE_BASE_URL,
  IMAGE_QURE_URL,
  DOCOMO_LOGIN_URL,
  DOCOMO_CLIENT_ID,
  DOCOMO_REDIRECT_URI,
  DOCOMO_SCOPE,
  DOCOMO_RESPONSE_TYPE,
  QURE_APPLICATION_ID,
  QURE_SECRET_KEY,
  QURE_TRACK_ACTION,
  QURE_DEFAULT_LANGUAGE,
  QURE_CHATBOT_URL,
  DEFAULT_DATE_FORMAT,
  CDN_REACT_DIST_URL,
  FAQ_APPLICATION_ID,
  FAQ_SECRET_KEY,
  UPGRADE_FLOW_FLAG,
  FAMILY_WARNING,
  LINE_BASE_URL,
  X_SEGMENT,
  RECAPTCHA_BASE_URL,
  RECAPTCHA_V3_SITE_KEY,
  RECAPTCHA_V2_SITE_KEY,
  SCANDIT_LICENSE_KEY,
  REACT_LOGIN_SUCCESS_EVENT,
  IMAGE_ALT_DEFAULT_VALUE,
  SCANDIT_SDK_URL,
  APPLICATION_ID,
  APPLICATION_KEY,
  APPLICATION_ID_BACKEND,
  APPLICATION_KEY_BACKEND,
  ADYEN_SCRIPT_URL,
  ADYEN_STYLES_URL,
  ADYEN_ORIGIN_KEY,
  ADN_FINGERPRINT_URL,
  ADN_ENVIRONMENT,
  ADDRESS_REGEX_VALIDATION,
  CDN_TRANSLATIONS_URL,
  DEBUG_TRANSLATIONS,
  DEBUG_TRANSLATIONS_ENABLED,
  CDN_DIGITAL_EVENT_URL,
  REGISTRATION_GRECAPTCHA_ACTION,
  VERIFY_EMAIL_PIN_GRECAPTCHA_ACTION,
  VERIFY_PHONE_PIN_GRECAPTCHA_ACTION,
  STOCK_NOTIFICATION_GRECAPTCHA_ACTION,
  RECOVER_PASSWORD_GRECAPTCHA_ACTION,
  RECOVER_ID_GRECAPTCHA_ACTION,
  CAPTCHA_VALIDATION_ERROR_01,
  CAPTCHA_VALIDATION_ERROR_02,
  EXPIRY_DATE_DELIMITER,
  COOKIE_REACT_OVERWRITE_ROUTE_REGISTER,
  COOKIE_SKIPPED_OCR,
  COOKIE_SHOW_SKIPPED_TOAST,
  DCX_PROMOTIONS_NOTIFICATIONS_SEEN,
  IQOSPHERE_PROFILE
}
